

































































import mixins from 'vue-typed-mixins';
import {ContactInfo} from "@/utils/ContactInfoUtils";
export default mixins().extend({
  props: {
    value: {
      type: Object as () => ContactInfo,
    },
  }
});
